// extracted by mini-css-extract-plugin
export default {"btWhatsapp":"WhatsAppPop_btWhatsapp__gD-wU","float":"WhatsAppPop_float__S9O4Z"};